export class DocumentKind {
  static OtherClaimDocument = 34;
  static PriceOffer = 47;

  static CostInvoiceForCarRent = 100;
  static CostInvoiceForParts = 101;
  static CostInvoiceForNBLLabour = 102;
  static CostInvoiceForSupportLabour = 103;
  static CostInvoiceTechnicianRepair = 104;
  static CostInvoiceTechnicianProvision = 105;
  static CostInvoiceTechnicianRepairAssembly = 106;
  static CostInvoiceOrderingPartyProvision = 107;
  static CostInvoiceServiceProvision = 108;

  static InvoiceForCarRepair = 109;
  static CostInvoiceForCarRentByWorkshop = 110;
  static CostInvoiceWorkshopComrehensiveRepair = 111;

  static SaleInvoice = 220;

  static ExportInvoicesToCalculationArt = 494;
  static ExportInvoicesAsJpkV7 = 495;
  static ExportCostInvoicesToCalculationArt = 496;
  static ExportCostInvoicesToRamzes = 497;
  static ExportCostInvoicesPaymentsToIng = 498;
  static MultipleProofs = 499;

  static CostEstimation = 500;
  static AdditionalCostEstimation = 501;
  static CostEstimationSentToAcceptation = 502;
  static CostEstimationAccepted = 503;
  static CostEstimationPartiallyAccepted = 504;
  static CostEstimationRejected = 505;
  static TotalLossClaim = 506;
  static AdditionalCostEstimationSentToAcceptation = 507;
  static AdditionalCostEstimationAccepted = 508;
  static AdditionalCostEstimationPartiallyAccepted = 509;
  static AdditionalCostEstimationRejected = 510;
  static TotalLossClaimAfterAdditionalCostEstimation = 511;

  static CarReceptionDataProtocolPhoto = 1020;
  
  static Inspectioncard = 3004;
  static PartsOrderInvoice = 3005;
  static CarReceptionData = 3007;
  static ReturnForCarReceptionData = 3008;
  static CarRentAgreement = 3009;
  static CarRentAgreementReturn = 3010;
  static BusinessTripDocument = 3011;
  static BusinessTripAttachment = 3012;
  static InvoiceAttachment = 3013;
  static CostInvoiceForClassification = 3014;

  static Invoice = 2100;
  static DuplicateInvoice = 2200;

  
  static isBasicDocument(documentKindId:number): boolean{
    return documentKindId < 500;
  }

  static isCostEstimationDocument(documentKindId:number): boolean{
    return (documentKindId == DocumentKind.CostEstimation || 
      documentKindId == DocumentKind.CostEstimationSentToAcceptation ||
      documentKindId == DocumentKind.CostEstimationAccepted ||
      documentKindId == DocumentKind.CostEstimationPartiallyAccepted ||
      documentKindId == DocumentKind.CostEstimationRejected ||
      documentKindId == DocumentKind.TotalLossClaim);

  }

  static isAdditionalCostEstimationDocument(documentKindId:number): boolean{
    return (documentKindId == DocumentKind.AdditionalCostEstimation || 
      documentKindId == DocumentKind.AdditionalCostEstimationSentToAcceptation ||
      documentKindId == DocumentKind.AdditionalCostEstimationAccepted ||
      documentKindId == DocumentKind.AdditionalCostEstimationPartiallyAccepted ||
      documentKindId == DocumentKind.AdditionalCostEstimationRejected ||
      documentKindId == DocumentKind.TotalLossClaimAfterAdditionalCostEstimation);

  }

  static isCostInvoiceDocument(documentKindId:number): boolean{
    return documentKindId >= 100 && documentKindId <= 140;
  }

  static isPartsOrderDocument(documentKindId:number): boolean{
    return (documentKindId == DocumentKind.PartsOrderInvoice || documentKindId == DocumentKind.PriceOffer);

  }

  static isSignableDoc(documentKindId:number): boolean{
    return documentKindId == DocumentKind.CarReceptionData ||
      documentKindId == DocumentKind.ReturnForCarReceptionData ||
      documentKindId == DocumentKind.CarRentAgreement ||
      documentKindId == DocumentKind.CarRentAgreementReturn;
  }

  static allowSendByEmail(documentKindId:number): boolean{
    return documentKindId == DocumentKind.CarReceptionData ||
      documentKindId == DocumentKind.ReturnForCarReceptionData ||
      documentKindId == DocumentKind.CarRentAgreement ||
      documentKindId == DocumentKind.CarRentAgreementReturn;
  }

  
}
